import React from 'react';
import classNames from 'classnames';
import './DndInputData.less';

interface IDndInputProps extends React.HTMLProps<HTMLDivElement> {}

/**
 * Component which is shown during dragging input data from toolbox to surface
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function DndInpuData({ className, ...otherProps }: IDndInputProps) {
  return <div className={classNames('dpc-dnd-input-data', className)} {...otherProps}></div>;
}
